<template>
  <div class="app-home-page" @touchstart="outFocus">
    <app-nav-page-view
      :tabHoverPage="0">
    </app-nav-page-view>
    <div class="app-banner-page-box" v-if="bannerList.length">
      <app-banner-page-view
        :bannerList="bannerList"
        @actionClickBanner="actionClickBanner"
      ></app-banner-page-view>
    </div>
    <app-title-page-view
      :titleObj="homeTitleObj"
    ></app-title-page-view>
    <div class="brief-introduction">
      <p class="title">上海<span>金保证</span>网络科技有限公司</p>
      <p class="english-title">Shanghai golden guarantee network technology co. LTD</p>
      <div>
        <p>
          上海金保证网络科技有限公司，地处上海漕河泾开发区，公司主力产品“斗票网”全国首家真正电影比价购票平台，
          主流电影票购票平台，实现轻松购票、快乐购票； “约车吧”是创新性聚合出行产品，实现多平台一键叫车、
          在线比价等功能，目前C端APP有百万级用户，B端与浦发、工商、交通、建设、北京、光大、中国等银行已深度合作。
          为企业客户提供高稳定性、高拓展性的产品，目前已拥有多项自主研发的技术方案。
        </p>
      </div>
    </div>
    <div class="computer-box">
      <img :src="computerImage" alt="">
      <h4>专注高质量高品质互联网服务</h4>
      <p>企业互联网高端应用商</p>
    </div>
    <app-title-page-view
      :titleObj="serviceProcessObj"
    ></app-title-page-view>
    <div class="service-process">
      <ul class="flex-middle-x">
        <li v-for="(item,index) in serviceList">
          <img :src="item.image" alt="">
          <h4>{{item.title}}</h4>
        </li>
      </ul>
    </div>
    <app-title-page-view
      :titleObj="serviceAdvantageObj"
    ></app-title-page-view>
    <ul class="service-advantage-list">
      <li class="flex-middle-x layout-flex-justify-content_space-between"
          v-for="(item,index) in serviceAdvantageList">
        <img :src="item.image" alt="">
        <div>
          <h4>{{item.title}}</h4>
          <p>{{item.content}}</p>
        </div>
      </li>
    </ul>
    <div class="contact-way">
      <img class="contact-way-title" :src="contactWayTitle" alt="">
      <input class="name"
             type="text"
             placeholder="姓名"
             v-model="inputName"
             @click="actionClickName">
      <input class="phone"
             type="tel"
             placeholder="手机"
             v-model="inputPhone"
             @click="actionClickPhone">
      <input class="email"
             type="text"
             placeholder="邮箱"
             v-model="inputEmail"
             @click="actionClickEmail">
      <textarea class="contact-content"
                name="" id="" cols="30" rows="10"
                placeholder="留言"
                v-model="guestBook"
                @click="actionClickContactContent"
      ></textarea>
      <div>
        <button @click="actionClickSubmit">
          <a :href="submitObj">提交</a>
        </button>
      </div>
      <p v-for="(item,index) in contactWayList">
        {{item.content}}
      </p>
    </div>
    <app-footer-page></app-footer-page>
  </div>
</template>
<script>
  import AppBannerPageView from '@/components/app/home/AppBannerPageView.vue'
  export default {
    name:'',
    data(){
      return {
        regPhone: /^1[0-9][0-9]{9}$/,
        /* eslint-disable */
        regMail:/[\w\$%&\*]{3,32}@[A-Za-z0-9]{2,16}(\.[a-z\u4e00-\u9fa5]{2,8})+$/,
        /* eslint-disable */
        inputName:'',
        inputPhone:null,
        inputEmail:'',
        guestBook:'',
        homeTitleObj:{
          mainHeading:'Company profile',
          subhead:'公司简介',
          content:''
        },
        serviceProcessObj:{
          mainHeading:'Service process',
          subhead:'我们的服务流程',
          content:'“按需求定制最优框架，提供简单易用操作体验，交付满意服务成果”'
        },
        serviceAdvantageObj:{
          mainHeading:'Service advantage',
          subhead:'我们的服务优势',
          content:'“创意，流程，执行缺一不可”'
        },
        computerImage:require('./image/computer-image.jpg'),
        contactWayTitle:require('./image/contact-way-title.png')
      }
    },
    components:{
      'app-banner-page-view':AppBannerPageView
    },
    computed:{
      submitObj(){
        if (this.isReg){
          return 'Mailto:pengdashuai@jinbaozheng.com?CC=' + '&Subject=' + this.guestBook +
            '&Body=姓名：' + this.inputName + ' 手机号：' + this.inputPhone + ' 邮箱：' +
            this.inputEmail + ' 留言：' + this.guestBook;
        } else {
          return 'javascript:void(0)';
        }
      },
      bannerList(){
        return [
          {imgUrl:require('./image/app-banner1.png')},
          {imgUrl:require('./image/app-banner2.png')},
          {imgUrl:require('./image/app-banner3.png')}
        ]
      },
      serviceList(){
        return [
          {image:require('./image/service1.png'), title:'需求分析'},
          {image:require('./image/service2.png'), title:'设计规划'},
          {image:require('./image/service3.png'), title:'设计实施'},
          {image:require('./image/service4.png'), title:'项目跟进'},
          {image:require('./image/service5.png'), title:'测试压测'},
          {image:require('./image/service6.png'), title:'成果检验'}
        ]
      },
      serviceAdvantageList(){
        return [
          {
            image: require('./image/quality.png'),
            title:'专及注品质追求',
            content:'从创始至今，我们的业务方向始终不变，专注做好一件事才能更好的追求高品质，这也是金保证存在\n' +
            '的价值。在未来我们也是基于此信念而继续创造。 '},
          {
            image: require('./image/preciseness.png'),
            title:'严谨的项目流程',
            content:'在不断的创新和实践中总结出可持续和可信赖的设\n' +
          '计流程，坚持与用户一起思考，用设计的方法发现\n' +
          '问题、解决问题、输出设计方案，并实现客户产品\n' +
          '和企业价值的提升。'},
          {
            image: require('./image/excellent.png'),
            title:'优秀的项目积累',
            content:'金保证积累了大量优秀的项目案例，并验证了设计\n' +
          '的价值。在不断的探索中总结经验，以结果为导向，\n' +
          '继续为更多客户提供优秀的设计优质项目。'}
        ]
      },
      contactWayList(){
        return [
          {content:'上海金保证网络科技有限公司'},
          {content:'地      址：上海闵行区宜山路1618号新意城C栋308'},
          {content:'电      话：021-61921322'},
          {content:'客服热线：021-61921322'},
          {content:'邮      箱：pengdashuai@jinbaozheng.com'}
        ]
      }
    },
    methods:{
      getMessage(value){
        this.$store.commit('showAlert',
          {
            alertList: {
              title: '' + value + '', errorCancel: false},
            show: true
          }
        );
      },
      actionClickSubmit(){
        if (!this.inputName){
          this.getMessage('姓名不可以为空');
          return;
        }
        if (!this.inputPhone){
          this.getMessage('手机不可以为空');
          return;
        }
        if (!this.inputEmail){
          this.getMessage('邮箱不可以为空');
          return;
        }
        if (!this.guestBook){
          this.getMessage('留言版不可以为空');
          return;
        }
        if (!this.regPhone.test(this.inputPhone)){
          this.getMessage('电话格式不正确');
          return;
        }
        if (!this.regMail.test(this.inputEmail)){
          this.getMessage('邮箱格式不正确');
        }
        this.isReg = true;
      },
      actionClickName(){
        this.$el.querySelector('.name').focus();
      },
      actionClickPhone(){
        this.$el.querySelector('.phone').focus();
      },
      actionClickEmail(){
        this.$el.querySelector('.email').focus();
      },
      actionClickContactContent(){
        this.$el.querySelector('.contact-content').focus();
      },
      outFocus: function () {
        if (document && document.querySelector('.name') ||
          document && document.querySelector('.phone') ||
          document && document.querySelector('.email') ||
          document && document.querySelector('.contact-content')){
          document.querySelector('.name').blur();
          document.querySelector('.phone').blur();
          document.querySelector('.email').blur();
          document.querySelector('.contact-content').blur();
        }
      },
      actionClickBanner(type, index){
        console.log(type)
        console.log(index)
      }
    }
  }
</script>
<style lang="scss" rel="stylesheet/scss" scoped="">
  .app-home-page{
    .app-banner-page-box{
      width:100%;
    }
    .brief-introduction{
      width:100%;
      background:$color-4;
      padding:0.2rem 0.3rem 0.45rem 0.3rem;
      text-align: left;
      .title{
        font-size:0.35rem;
        color:#555555;
        span{
          color:#ffca4c;
        }
      }
      .english-title{
        font-size:0.3rem;
        color:$color-3;
        padding-top:0.18rem;
      }
      div{
        width:6.9rem;
        height:3.5rem;
        font-size:0.28rem;
        color:$color-3;
        margin-top:0.2rem;
        padding:0.15rem 0 0 0.1rem;
        background:url('./image/title-content.jpg') no-repeat;
        background-size:100% 100%;
        p{
          width:6.5rem;
          height:2.5rem;
          text-align: justify;
          word-break: break-all;
        }
      }
    }
    .computer-box{
      width:100%;
      position: relative;
      img{
        width:100%;
      }
      h4{
        font-size:0.48rem;
        color:$color-4;
        position: absolute;
        top:3.5rem;left:0;right:0;bottom:0;
        margin:auto;
      }
      p{
        font-size:0.3rem;
        color:#f3f3f3;
        position: absolute;
        top:4.5rem;left:0;right:0;bottom:0;
        margin:auto;
      }
    }
    .service-process{
      width:100%;
      background:$color-4;
      padding:0 0.3rem;
      ul{
        width:100%;
        height:5.4rem;
        flex-wrap: wrap;
        background:url('./image/service-process-background.jpg');
        background-size:100% 100%;
        position: relative;
        li{
          position: absolute;
          width:1.3rem;
          img{
            width:1rem;
          }
          h4{
            font-size:0.16rem;
            color:$color-black;
            white-space: normal;
          }
        }
        li:nth-child(1){
          top:0.3rem;left:0.2rem;
        }
        li:nth-child(2){
          top:0.3rem;left:2.6rem;
        }
        li:nth-child(3){
          top:0.3rem;left:5.1rem;
        }
        li:nth-child(4){
          top:3.6rem;left:0.2rem;
        }
        li:nth-child(5){
          top:3.6rem;left:2.6rem;
        }
        li:nth-child(6){
          top:3.6rem;left:5.1rem;
        }
      }
    }
    .service-advantage-list{
      padding:0.3rem 0.3rem 0 0.3rem;
      text-align: left;
      background:$color-4;
      li{
        padding-bottom:0.7rem;
        text-align: justify;
        word-break: break-all;
        img{
          width:1rem;
          padding-right:0.5rem;
        }
        h4{
          font-size:0.3rem;
          color:#555555;
        }
        p{
          font-size:0.24rem;
          color:$color-3;
          margin-top:0.1rem;
        }
      }
    }
    .contact-way{
      width:100%;
      background:url('./image/contact-way-backgroud.jpg');
      background-size:100% 100%;
      padding:0.3rem 0.3rem 0.6rem 0.3rem;
      font-size:0.28rem;
      color:#cacaca;
      text-align: left;
      .contact-way-title{
        width:100%;
      }
      input{
        width:4.2rem;
        height:0.8rem;
        margin-top:0.15rem;
        padding-left:0.05rem;
      }
      textarea{
        width:100%;
        height:1.9rem;
        margin-top:0.15rem;
        padding-left:0.05rem;
        outline: none;
      }
      div{
        width:100%;
        text-align: center;
        padding:0.6rem;
        button{
          width:4.62rem;
          height:0.75rem;
          border: 1px solid #ffbd1f;
          background:transparent;
          color:#ffbd1f;
          font-size:0.36rem;
          a{
            width:100%;
            color:#ffbd1f;
            font-size:16px;
          }
        }
      }
      p{
        font-size:0.28rem;
        color:#eaeaea;
        margin-top:0.2rem;
      }
    }
  }
</style>
